import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useLandingPage } from "../../hooks/useLandingPage";

/**
 * Simple redirect component for stepper routes
 * Redirects completed users to tab routes
 */
export default function ProfileRedirect({ stepperPath, tabPath, children }) {
  const { isOnboardingComplete, isLoading } = useLandingPage();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    // If user completed onboarding, redirect to tab route
    if (isOnboardingComplete) {
      navigate(tabPath, { replace: true });
    }
  }, [isOnboardingComplete, isLoading, navigate, tabPath]);

  // If still loading or redirecting, show nothing
  if (isLoading || isOnboardingComplete) {
    return null;
  }

  // Otherwise, render the stepper page
  return children;
}
